export const NAME_PATTERN = '[A-Za-z0-9- ]{1,16}'
